import { useQuery } from '@tanstack/react-query';
import { http } from '@/lib/http';
import type { DashboardCounters } from './types';

// Dashboard queries per docs/ui/operator-ui-tds.md §6.2. These now read a cheap
// O(1) Redis-backed counters read-model (data-platform reconcile job, §11), so a
// background poll is cheap — `refetchInterval` keeps the dashboard LIVE instead of
// frozen on the first load (the counters refresh as the reconcile job updates
// Redis). `refetchIntervalInBackground` so it keeps current even when the operator
// is on another tab.

export function useDashboardCounters() {
  return useQuery<DashboardCounters>({
    queryKey: ['dashboard', 'counters'],
    queryFn: () => http.get('v1/dashboard/counters').json<DashboardCounters>(),
    staleTime: 15_000,
    refetchInterval: 30_000,
    refetchIntervalInBackground: true,
  });
}

// useNeedsAttention is GONE with the dashboard's needs-attention panel (operator
// feedback) — the /cases needs-attention BUCKET remains the home of that queue.
